import { Provider } from '@angular/core';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions } from '@angular/material/checkbox';
import { MAT_CHIPS_DEFAULT_OPTIONS, MatChipsDefaultOptions } from '@angular/material/chips';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MAT_LIST_CONFIG, MatListConfig } from '@angular/material/list';
import { MAT_SELECT_CONFIG, MatSelectConfig } from '@angular/material/select';

export const GRID_MATERIAL_FORM_FIELD_DEFAULTS: MatFormFieldDefaultOptions = {
    appearance: 'fill',
    subscriptSizing: 'dynamic'
};

export const GRID_MATERIAL_CHECKBOX_DEFAULTS: MatCheckboxDefaultOptions = {
    color: 'primary'
};

export const GRID_MATERIAL_CHIPS_DEFAULTS: MatChipsDefaultOptions = {
    hideSingleSelectionIndicator: true,
    separatorKeyCodes: []
};

export const GRID_MATERIAL_LIST_DEFAULTS: MatListConfig = {
    hideSingleSelectionIndicator: true
};

export const GRID_MATERIAL_SELECT_DEFAULTS: MatSelectConfig = {
    hideSingleSelectionIndicator: true
};

export const GRID_MATERIAL_PROVIDERS: Provider[] = [
    {
        provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
        useValue: GRID_MATERIAL_FORM_FIELD_DEFAULTS
    },
    {
        provide: MAT_CHIPS_DEFAULT_OPTIONS,
        useValue: GRID_MATERIAL_CHIPS_DEFAULTS
    },
    {
        provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
        useValue: GRID_MATERIAL_CHECKBOX_DEFAULTS
    },
    {
        provide: MAT_LIST_CONFIG,
        useValue: GRID_MATERIAL_LIST_DEFAULTS
    },
    {
        provide: MAT_SELECT_CONFIG,
        useValue: GRID_MATERIAL_SELECT_DEFAULTS
    }
];
